const baseStyle = {
    '.MuiListItemIcon-root': {
        minWidth: '40px',
        marginRight: '8px'
    },
    '.MuiListItemText-primary': {
        fontWeight: 'normal'
    },
    margin: '8px 15px',
    padding: '5px 8px',
    borderRadius: '5px',
};

const listItemTextStyle = {
    '.MuiListItemText-primary': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '0.875rem',
    },
};

const chatSessionStyle = {
    height: '35px',
    minWidth: '100%',
    justifyContent: 'flex-start',
    marginLeft: '0px',
    ...baseStyle
};

const textFieldStyle = {
    width: 'calc(100% - 64px)',
    '& .MuiInputBase-input': {
        height: '30px',
        padding: '0px 0px',
        fontSize: '0.875rem',
        backgroundColor: 'transparent',
        color: 'inherit',
    },
    '& .MuiOutlinedInput-root': {
        minHeight: '30px',
        backgroundColor: 'transparent',
        '& fieldset': {
            border: 'none',
        },
        '&:hover fieldset': {
            border: 'none',
        },
        '&.Mui-focused fieldset': {
            border: 'none',
        },
    },
};

const iconStyle = {
    fontSize: '14px'
};

const buttonStyle = {
    padding: 4
};

const tabStyleChat = {
    height: '35px',
    minWidth: '100%',
    justifyContent: 'flex-start',
    marginLeft: '0px',
};

export const chatHistoryStyles = {
    baseStyle,
    listItemTextStyle,
    chatSessionStyle,
    textFieldStyle,
    iconStyle,
    buttonStyle,
    tabStyleChat
}

export const isCustomChat = (chat) => chat?.chatModel || chat?.chatIcon || chat?.chatInstructions